'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"];
import tinymce from 'tinymce';
import MarginControlButton from 'rich-text-lib/components/toolbar/MarginControlButton';
import { CANVAS_MARGINS } from '../../../constants/toolbar';
import { getPluginSetting } from '../../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function addContextualMarginControls(editor) {
  const handleMarginChange = (target, margin) => {
    editor.fire('hsMarginChange', {
      target,
      margin
    });
  };
  tinymce.canvas.addButton(editor, CANVAS_MARGINS, {
    renderControl: props => {
      const {
          contextualNodeAttributes
        } = props,
        rest = _objectWithoutPropertiesLoose(props, _excluded);
      const {
        margin = {},
        marginIconType,
        activeElement
      } = contextualNodeAttributes;
      return /*#__PURE__*/_jsx(MarginControlButton, Object.assign({}, rest, {
        margin: margin,
        marginIconType: marginIconType,
        dropdownClassName: "mce-dropdown",
        onMarginChange: handleMarginChange.bind(null, activeElement),
        staticPrefix: getPluginSetting(editor, 'richTextLibStaticPrefix')
      }));
    }
  });
}